import React, {useContext} from "react";
import save from "../../../../../../assets/save.svg";
import {GlobalContext} from "../../../../../../App.tsx";
import {MessageBottomContainerContext} from "../../../Message.tsx";
import {useAppStore} from "../../../../../../GlobalStore/GlobalStore.ts";
import {addAdjacentMessage} from "../../../../../../Utils/messageObject/messageObjectUtils.ts";
import {stopPlaying} from "../../../../../../Utils/misc/playAudio.ts";

interface SaveProps {}

const Save: React.FC<SaveProps> = ({ }) => {
    const { handleSubmitHelper, messagesRef, currentMessageRef, messagesSequenceRef, miscMidRenderRefs, llmRequestRefs } = useContext(GlobalContext);
    const { group, editedContent, setEditedContent } = useContext(MessageBottomContainerContext);
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { editingId, canSubmit } = dynamicStateObj;


    const handleSaveClick = () => {
        if (!canSubmit) return;

        if (editingId && miscMidRenderRefs.current.playingId && editingId <= miscMidRenderRefs.current.playingId) {
            stopPlaying(setDynamicStateObj, miscMidRenderRefs);
        }

        addAdjacentMessage(
            editedContent.filter((item: any) => (!item.removeOnRegenerate && item.type !== "text") || (item.type === "text" && item.text.trim() !== "")),
            group.index,
            messagesRef,
            currentMessageRef,
            messagesSequenceRef,
            llmRequestRefs
        );

        handleSubmitHelper();
        setDynamicStateObj({editingId: null});
        setEditedContent([]);
    };

    return (
        <button
            className={`h-5 w-5 ml-1.5 mr-0.5 cursor-pointer ${!canSubmit ? "opacity-30 cursor-default" : ""}`}
            onClick={handleSaveClick}
        >
            <img
                src={`${save}`}
                alt="Save"
                onClick={handleSaveClick}
            />
        </button>
    )
}

export default Save;
